// import { Space, Tabs, Radio, Select, Tag, Input, Card } from "antd";
// import { useContext, useEffect, useState } from "react";

// import { Context } from "../../context";
// import { Fetch, Post } from "../../fetch";
// import { convertIdToKey } from "../../utils";
// import UploadSubtitles from "./subtitles";
// import UploadTrailer from "./trailers";
// import UploadVideo from "./videos";
// import VerticalShortTranscodingUpload from "./VerticalShortTranscodingUpload";
// const { TabPane } = Tabs;
// const { TextArea } = Input;
// const { Option } = Select;

// const UploadContent = () => {
//   const [contentType, setContentType] = useState("movie");
//   const [movies, setMovies] = useState([]);
//   const [episodes, setEpisodes] = useState([]);
//   const [series, setSeries] = useState([]);
//   const [songs, setSongs] = useState([]);
//   const [activeObj, setActiveObj] = useState({});
//   const [upload, setUpload] = useState({
//     id: null,
//     season: null,
//     episode: null,
//     type: "",
//   });

//   const initUpload = {
//     id: null,
//     season: null,
//     episode: null,
//     type: "",
//   };

//   const { token, apiUrl, superAdmin } = useContext(Context);

//   useEffect(() => {
//     Fetch(`${apiUrl}/movies`, token, (result) => {
//       const movs = convertIdToKey(result.movies);
//       setMovies(movs);
//     });

//     Fetch(`${apiUrl}/series`, token, (result) => {
//       const series = convertIdToKey(result.series);
//       setSeries(series);
//     });

//     Fetch(`${apiUrl}/songs`, token, (result) => {
//       const songs = convertIdToKey(result.songs);
//       setSongs(songs);
//     });
//   }, [apiUrl, token]);

//   useEffect(() => {
//     if (
//       upload.type === "episode" &&
//       upload._id &&
//       upload._id.includes("_") === false
//     ) {
//       Fetch(`${apiUrl}/series/${upload._id}episodes`, token, (result) => {
//         setEpisodes(result.episodes);
//       });
//     }
//   }, [upload]);
//   useEffect(() => {
//     Fetch(`${apiUrl}/webseries?filterBy=all`, token, (result) => {
//       console.log("Vertical Shorts API Response:", result);
  
//       const webseries = convertIdToKey(result.webseries || []);
//       setSeries(webseries);
//     });
//   }, [apiUrl, token]);

//   useEffect(() => {
//     setActiveObj({});
//     setUpload(initUpload);
//   }, [contentType]);

//   return (
//     <div className="add-content-wrapper">
//       <h3>Upload Content</h3>
//       <Space direction="vertical">
//         <Radio.Group
//           className="content-type-option"
//           value={contentType}
//           onChange={(e) => setContentType(e.target.value)}
//         >
//           <Radio value="movie">Movie</Radio>
//           <Radio value="series">Series</Radio>
//           <Radio value="episode">Episode</Radio>
//           <Radio value="song">Song</Radio>
//           <Radio value="verticalShortsTranscoding">Vertical Shorts Transcoding</Radio>
//         </Radio.Group>
//         {contentType === "verticalShortsTranscoding" && upload?._id && (
//   <>
//     <Select
//       style={{ width: 300 }}
//       placeholder={"Select Vertical Series"}
//       allowClear
//       showSearch
//       optionFilterProp="children"
//       onClear={() => {
//         setActiveObj({});
//         setUpload(initUpload);
//       }}
//       onChange={(val) => {
//         setUpload({
//           ...upload,
//           _id: val,
//           type: "vertical_shorts",
//         });

//         setActiveObj(series.find((s) => s.key === val));
//       }}
//     >
//       {series.map((content) => (
//         <Select.Option key={content.key} value={content.key}>
//           {content.title}
//         </Select.Option>
//       ))}
//     </Select>
//   </>
// )}
//         {contentType === "movie" && (
//           <>
//             <Select
//               style={{ width: 300 }}
//               placeholder={"Select Movie"}
//               allowClear
//               showSearch
//               optionFilterProp="children"
//               onClear={() => {
//                 setActiveObj({});
//                 setUpload(initUpload);
//               }}
//               onChange={(val) => {
//                 setUpload({
//                   ...upload,
//                   _id: val,
//                   type: "movies",
//                   episode: null,
//                   season: null,
//                 });
//                 setActiveObj(movies.find((m) => m.key === val));
//               }}
//             >
//               {movies.map((content) => (
//                 <Select.Option key={content.key} value={content.key}>
//                   {content.title}
//                 </Select.Option>
//               ))}
//             </Select>
//           </>
//         )}
//         {contentType === "series" && (
//           <>
//             <Select
//               style={{ width: 300 }}
//               placeholder={"Select Series"}
//               allowClear
//               showSearch
//               optionFilterProp="children"
//               onClear={() => {
//                 setActiveObj({});
//                 setUpload(initUpload);
//               }}
//               onChange={(val) => {
//                 setUpload({
//                   ...upload,
//                   _id: val,
//                   type: "series",
//                   episode: null,
//                   season: null,
//                 });
//                 setActiveObj(series.find((m) => m.key === val));
//               }}
//             >
//               {series.map((content) => (
//                 <Select.Option key={content.key} value={content.key}>
//                   {content.title}
//                 </Select.Option>
//               ))}
//             </Select>
//           </>
//         )}
//         {contentType === "episode" && (
//           <Space direction="horizontal">
//             <Select
//               style={{ width: 300 }}
//               placeholder={"Select Series"}
//               allowClear
//               showSearch
//               optionFilterProp="children"
//               onClear={() => {
//                 setActiveObj({});
//                 setUpload(initUpload);
//               }}
//               onChange={(val) =>
//                 setUpload({
//                   ...upload,
//                   _id: val,
//                   key: val,
//                   type: "episode",
//                   season: null,
//                   episode: null,
//                 })
//               }
//             >
//               {series.map((content) => (
//                 <Select.Option key={content.key} value={content.key}>
//                   {content.title}
//                 </Select.Option>
//               ))}
//             </Select>
//             <Select
//               style={{ width: 300 }}
//               placeholder={"Select Episode"}
//               allowClear
//               showSearch
//               optionFilterProp="children"
//               onClear={() => {
//                 setActiveObj({});
//                 setUpload(initUpload);
//               }}
//               onChange={(v, _) => {
//                 setUpload({
//                   ...upload,
//                   season: v.split("_")[0],
//                   episode: v.split("_")[1],
//                   type: "episode",
//                   _id: `${upload.key}_${v}`,
//                 });
//                 setActiveObj(
//                   episodes.find(
//                     (ep) =>
//                       v.split("_")[0] == ep.season &&
//                       ep.number == v.split("_")[1]
//                   )
//                 );
//               }}
//             >
//               {episodes.map((e) => (
//                 <Select.Option
//                   key={`${e.season}_${e.number}`}
//                   value={`${e.season}_${e.number}`}
//                 >
//                   {e.name}
//                 </Select.Option>
//               ))}
//             </Select>
//           </Space>
//         )}
//         {contentType === "song" && (
//           <>
//             <Select
//               style={{ width: 300 }}
//               placeholder={"Select Song"}
//               allowClear
//               showSearch
//               optionFilterProp="children"
//               onClear={() => setActiveObj({})}
//               onChange={(val) => {
//                 setUpload({
//                   ...upload,
//                   _id: val,
//                   type: "songs",
//                   episode: null,
//                   season: null,
//                 });
//                 setActiveObj(songs.find((m) => m.key === val));
//               }}
//             >
//               {songs.map((content) => (
//                 <Select.Option key={content.key} value={content.key}>
//                   {content.title}
//                 </Select.Option>
//               ))}
//             </Select>
//           </>
//         )}

//         {/* Videos module */}
//         {(["movie", "song"].includes(contentType) && upload._id) ||
//         (contentType === "episode" && "_id" in upload && upload.episode) ? (
//           <UploadVideo
//             id={
//               activeObj && "_id" in activeObj
//                 ? activeObj._id
//                 : `contentupload-${contentType}`
//             }
//             upload={{ ...upload }}
//             activeObj={activeObj ? activeObj : {}}
//           />
//         ) : null}

//         {/* Trailers module */}
//         {["movie", "series"].includes(contentType) && upload._id ? (
//           <UploadTrailer
//             id={
//               activeObj && "_id" in activeObj
//                 ? activeObj._id
//                 : `trailerupload-${contentType}`
//             }
//             upload={{
//               ...upload,
//               type:
//                 upload.type === "movies" ? "movie_trailer" : "series_trailer",
//             }}
//             activeObj={activeObj ? activeObj : {}}
//           />
//         ) : null}

//         {/* Subtitles module */}
//         {(["movie", "song"].includes(contentType) && upload._id) ||
//         (contentType === "episode" && "_id" in upload && upload.episode) ? (
//           <Card title={"Subtitles (only SRT)"}>
//             <UploadSubtitles
//               id={
//                 activeObj && "_id" in activeObj
//                   ? activeObj._id
//                   : `Srt-${contentType}`
//               }
//               upload={{
//                 ...upload,
//                 _id: upload._id,
//                 type: contentType,
//               }}
//               subtitles={
//                 activeObj && "subtitles" in activeObj ? activeObj.subtitles : {}
//               }
//             />
//           </Card>
//         ) : null}
//         {/* {contentType === "verticalShortsTranscoding" && upload && (
//   <VerticalShortTranscodingUpload
//     upload={upload}
//     onRefresh={() => {
//       if (!upload?._id) return;

//       fetch(`${apiUrl}/webseries/${upload._id}?admin=true`)
//         .then((res) => res.json())
//         .then((data) => setActiveObj(data)); */}
//     {/* }}
//   />
// )} */}
        
//       </Space>
//     </div>
//   );

// };

// export default UploadContent;
import { Space, Radio, Select, Card } from "antd";
import { useContext, useEffect, useState } from "react";

import { Context } from "../../context";
import { Fetch } from "../../fetch";
import { convertIdToKey } from "../../utils";

import UploadSubtitles from "./subtitles";
import UploadTrailer from "./trailers";
import UploadVideo from "./videos";
import VerticalShortTranscodingUpload from "./VerticalShortTranscodingUpload";

const UploadContent = () => {
  const [contentType, setContentType] = useState("movie");

  const [movies, setMovies] = useState([]);
  const [episodes, setEpisodes] = useState([]);
  const [series, setSeries] = useState([]);
  const [songs, setSongs] = useState([]);

  // 🔥 NEW: separate state for vertical shorts
  const [verticalSeries, setVerticalSeries] = useState([]);

  const [activeObj, setActiveObj] = useState({});
  const [upload, setUpload] = useState({
    id: null,
    season: null,
    episode: null,
    type: "",
  });

  const initUpload = {
    id: null,
    season: null,
    episode: null,
    type: "",
  };

  const { token, apiUrl } = useContext(Context);

  // 🔥 Load normal data
  useEffect(() => {
    Fetch(`${apiUrl}/movies`, token, (result) => {
      setMovies(convertIdToKey(result.movies || []));
    });

    Fetch(`${apiUrl}/series`, token, (result) => {
      setSeries(convertIdToKey(result.series || []));
    });

    Fetch(`${apiUrl}/songs`, token, (result) => {
      setSongs(convertIdToKey(result.songs || []));
    });
  }, [apiUrl, token]);

  // 🔥 Load vertical shorts separately
  useEffect(() => {
    Fetch(`${apiUrl}/webseries?filterBy=all`, token, (result) => {
      console.log("Vertical Shorts API:", result);

      const data =
        result.webseries ||
        result.data ||
        result ||
        [];

      setVerticalSeries(convertIdToKey(data));
    });
  }, [apiUrl, token]);

  // Episode fetch
  useEffect(() => {
    if (
      upload.type === "episode" &&
      upload._id &&
      !upload._id.includes("_")
    ) {
      Fetch(`${apiUrl}/series/${upload._id}/episodes`, token, (result) => {
        setEpisodes(result.episodes || []);
      });
    }
  }, [upload]);

  // Reset on type change
  useEffect(() => {
    setActiveObj({});
    setUpload(initUpload);
  }, [contentType]);

  return (
    <div className="add-content-wrapper">
      <h3>Upload Content</h3>

      <Space direction="vertical">

        {/* 🔥 RADIO */}
        <Radio.Group
          value={contentType}
          onChange={(e) => setContentType(e.target.value)}
        >
          <Radio value="movie">Movie</Radio>
          <Radio value="series">Series</Radio>
          <Radio value="song">Song</Radio>
          <Radio value="verticalShortsTranscoding"> Vertical Shorts Transcoding</Radio>
        </Radio.Group>

        {/* ================= MOVIE ================= */}
        {contentType === "movie" && (
          <Select
            style={{ width: 300 }}
            placeholder="Select Movie"
            allowClear
            showSearch
            onChange={(val) => {
              setUpload({ _id: val, type: "movies" });
              setActiveObj(movies.find((m) => m.key === val));
            }}
          >
            {movies.map((m) => (
              <Select.Option key={m.key} value={m.key}>
                {m.title}
              </Select.Option>
            ))}
          </Select>
        )}

        {/* ================= SERIES ================= */}
        {contentType === "series" && (
          <Select
            style={{ width: 300 }}
            placeholder="Select Series"
            allowClear
            showSearch
            onChange={(val) => {
              setUpload({ _id: val, type: "series" });
              setActiveObj(series.find((s) => s.key === val));
            }}
          >
            {series.map((s) => (
              <Select.Option key={s.key} value={s.key}>
                {s.title}
              </Select.Option>
            ))}
          </Select>
        )}

        {/* ================= SONG ================= */}
        {contentType === "song" && (
          <Select
            style={{ width: 300 }}
            placeholder="Select Song"
            allowClear
            showSearch
            onChange={(val) => {
              setUpload({ _id: val, type: "songs" });
              setActiveObj(songs.find((s) => s.key === val));
            }}
          >
            {songs.map((s) => (
              <Select.Option key={s.key} value={s.key}>
                {s.title}
              </Select.Option>
            ))}
          </Select>
        )}

        {/* ================= 🔥 VERTICAL SHORTS ================= */}
        {contentType === "verticalShortsTranscoding" && (
          <>
            <Select
              style={{ width: 300 }}
              placeholder="Select Vertical Series"
              allowClear
              showSearch
              optionFilterProp="children"
              onChange={(val) => {
                const picked = verticalSeries.find((s) => s.key === val);
                setUpload({
                  _id: val,
                  type: "vertical_shorts",
                  category: "series",
                  title: picked?.title,
                });

                setActiveObj(picked);
              }}
            >
              {verticalSeries.map((s) => (
                <Select.Option key={s.key} value={s.key}>
                  {s.title}
                </Select.Option>
              ))}
            </Select>

            {/* Upload Component */}
            {upload?._id && (
              <VerticalShortTranscodingUpload
                upload={upload}
                onRefresh={() => {
                  fetch(`${apiUrl}/webseries/${upload._id}?admin=true`)
                    .then((res) => res.json())
                    .then((data) => setActiveObj(data));
                }}
              />
            )}
          </>
        )}

        {/* ================= EXISTING MODULES ================= */}
        {["movie", "song"].includes(contentType) && upload._id && (
          <UploadVideo upload={upload} activeObj={activeObj} />
        )}

        {["movie", "series"].includes(contentType) && upload._id && (
          <UploadTrailer upload={upload} activeObj={activeObj} />
        )}

        {["movie", "song"].includes(contentType) && upload._id && (
          <Card title="Subtitles">
            <UploadSubtitles upload={upload} />
          </Card>
        )}

      </Space>
    </div>
  );
};

export default UploadContent;
